import React, { useState } from 'react';

import styled from 'styled-components';

import ViewInputModalCommunityRentalTypes from './ViewInputModalCommunityRentalTypes';
import ConfirmModal from '../../../../common/Modal/ConfirmModal';
import Input from '../../../lib/Input';
import { VIEW_MODALS, VIEW_MODALS_CONTENT } from '../../constants';

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: space-around;
  flex-grow: 1;
  padding-bottom: 20px;
`;

const Label = styled.span`
  font-family: var(--font-bold);
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  flex-flow: column;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
`;

interface Props {
  open: boolean;
  type: string;
  loading: boolean;
  communityContractType?: number;
  onConfirm: any;
  onCancel: any;
  setCommunityContractType?: (val: number) => void;
}

const ViewInputModal = ({
  open,
  type,
  loading,
  communityContractType,
  setCommunityContractType,
  onConfirm,
  onCancel,
}: Props) => {
  const [name, setName] = useState<string>('');

  const handleConfirm = () => {
    onConfirm(name);
  };

  const handleChange = (e: any) => {
    setName(e.target.value);
  };

  return (
    <ConfirmModal
      open={open}
      title={VIEW_MODALS_CONTENT[type].title}
      description={VIEW_MODALS_CONTENT[type].description}
      confirmLabel={VIEW_MODALS_CONTENT[type].label}
      onConfirm={handleConfirm}
      onCancel={onCancel}
      loading={loading}
      disabled={type != VIEW_MODALS.DELETE && type !== VIEW_MODALS.RESET_LAYOUT && name.length == 0}
    >
      <Content>
        {type === VIEW_MODALS.ADD && setCommunityContractType && (
          <ViewInputModalCommunityRentalTypes
            communityContractType={communityContractType}
            setCommunityContractType={setCommunityContractType}
          />
        )}
        {VIEW_MODALS_CONTENT[type].showInput && (
          <InputContainer>
            <Label>View Name</Label>
            <Input placeholder={'Enter a name'} onChange={handleChange} />
          </InputContainer>
        )}
      </Content>
    </ConfirmModal>
  );
};

export default ViewInputModal;
